"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _react = _interopRequireDefault(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _PopoverMenu = _interopRequireDefault(require("../../../common/PopoverMenu/PopoverMenu"));
var _reduxForm = require("redux-form");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
var InnerInstumentSelector = function InnerInstumentSelector(props) {
  var bemClasses = props.bemClasses,
    instrumentsSymbols = props.instrumentsSymbols,
    selectedInstrument = props.selectedInstrument;
  var options = props.options || [];
  return /*#__PURE__*/_react["default"].createElement(_PopoverMenu["default"], {
    customClass: bemClasses('instrument-selector'),
    popoverProps: {
      trigger: function trigger(props) {
        return /*#__PURE__*/_react["default"].createElement("div", _extends({
          className: bemClasses('instrument-container')
        }, props), /*#__PURE__*/_react["default"].createElement("div", {
          className: bemClasses('symbols-wrapper')
        }, instrumentsSymbols), /*#__PURE__*/_react["default"].createElement("div", {
          className: bemClasses('instruments-name')
        }, selectedInstrument), /*#__PURE__*/_react["default"].createElement("div", {
          className: bemClasses('triangles-container')
        }, /*#__PURE__*/_react["default"].createElement("span", {
          className: 'triangle-up'
        }), /*#__PURE__*/_react["default"].createElement("span", {
          className: 'triangle-down'
        })));
      },
      customClass: 'instrument-selector'
    },
    items: options
  });
};
var RetailInstumentSelector = function RetailInstumentSelector(props) {
  return /*#__PURE__*/_react["default"].createElement(_reduxForm.Field, _extends({
    name: props.name,
    component: InnerInstumentSelector
  }, props));
};
RetailInstumentSelector.defaultProps = {
  name: '',
  instrumentsSymbols: ''
};
RetailInstumentSelector.propTypes = {
  name: _propTypes["default"].string,
  instrumentsSymbols: _propTypes["default"].string,
  selectedInstrument: _propTypes["default"].string.isRequired,
  bemClasses: _propTypes["default"].func
};
var _default = exports["default"] = RetailInstumentSelector;